export const PIN_CODE_VALIDATION = "/public/get-city";
